import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ReactPaginate from "react-paginate";

const Withdrawlhistory = () => {
  const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
  const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LIVE_API;
  const nodeMode = process.env.NODE_ENV;
  const baseUrl = nodeMode === "development" ? beckendLocalApiUrl : beckendLiveApiUrl;

  const [data, setData] = useState([]);
  const [pageNumber, setPageNumber] = useState(0);
  const [limit, setLimit] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const [search, setSearch] = useState('');

  const fetchHistory = (page = pageNumber, lim = limit, q = search) => {
    const access_token = localStorage.getItem("token");
    const headers = { Authorization: `Bearer ${access_token}` };
    let url = baseUrl + `temp/withdraw/all/success?page=${page}&_limit=${lim}`;
    if (q) url += `&_q=${encodeURIComponent(q)}&_stype=Name`;
    axios.get(url, { headers })
      .then((res) => {
        setData(res.data.data || []);
        setTotalPages(res.data.totalPages || 0);
        setPageNumber(page);
        setLimit(lim);
        setSearch(q);
      })
      .catch((e) => console.log(e));
  };

  useEffect(() => {
    fetchHistory(0, limit, '');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const dateFormat = (e) => {
    if (!e) return "N/A";
    const date = new Date(e);
    return date.toLocaleString('default', { month: 'short', day: 'numeric', hour: 'numeric', hour12: true, minute: 'numeric' });
  };

  return (
    <div className="row ">
      <div className="col-12 grid-margin">
        <div className="card">
          <div className="card-body">
            <h4 className="card-title">Withdrawl history</h4>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', alignItems: 'center', marginBottom: '15px' }}>
              <input
                type="text"
                placeholder="Search by player name..."
                defaultValue={search}
                onKeyDown={(e) => { if (e.key === 'Enter') fetchHistory(0, limit, e.target.value); }}
                className="form-control"
                style={{ maxWidth: '260px' }}
              />
              <select className="form-control" style={{ maxWidth: '160px' }} value={limit} onChange={(e) => fetchHistory(0, e.target.value, search)}>
                <option value="10">Show 10</option>
                <option value="20">Show 20</option>
                <option value="50">Show 50</option>
                <option value="100">Show 100</option>
              </select>
            </div>
            <div className="table-responsive">
              <table className="table">
                <thead>
                <tr>
                      <th>#</th>
                      <th> ID</th>
                      <th> Username</th>
                      <th> Phone</th>
                      <th> Amount </th>
                      <th> Status </th>
                      <th> Date </th>
                    </tr>
                </thead>
                <tbody>
            {data.map((item, index) => {
                return(
                  <tr key={item._id}>
                    <td>{(pageNumber > 0 ? (pageNumber - 1) * limit : 0) + index + 1}</td>
                    <td>{item._id}</td>
                    <td>
                      {item.user && <Link to={`/user/view_user/${item.user._id}`}>{item.user.Name}</Link>}
                    </td>
                    <td>{item.user && item.user.Phone}</td>
                    <td>₹{item.amount}</td>
                    <td>
                      <span className={`badge ${item.status === 'success' ? 'badge-success' : 'badge-danger'}`}>{item.status}</span>
                    </td>
                    <td>{dateFormat(item.updatedAt)}</td>
                  </tr>
                )})}
                  {data.length === 0 && (
                    <tr><td colSpan="7" style={{ textAlign: 'center', padding: '40px' }}>No withdrawal history found.</td></tr>
                  )}
                </tbody>
              </table>
            </div>
            {totalPages > 1 && (
              <div style={{ display: 'flex', justifyContent: 'center', marginTop: '15px' }}>
                <ReactPaginate
                  previousLabel={"←"}
                  nextLabel={"→"}
                  breakLabel={"..."}
                  pageCount={totalPages}
                  marginPagesDisplayed={1}
                  pageRangeDisplayed={2}
                  onPageChange={(d) => fetchHistory(d.selected + 1, limit, search)}
                  containerClassName={"pagination"}
                  pageClassName={"page-item"}
                  pageLinkClassName={"page-link"}
                  previousClassName={"page-item"}
                  previousLinkClassName={"page-link"}
                  nextClassName={"page-item"}
                  nextLinkClassName={"page-link"}
                  activeClassName={"active"}
                  forcePage={pageNumber > 0 ? pageNumber - 1 : 0}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Withdrawlhistory;
